module.exports = __webpack_public_path__ + "img/default.14a62065.svg";